module.exports = __webpack_public_path__ + "img/Group796.9e02616e.png";